import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { closeLocationCalendar, updateCalendarView, updateCalendarDate, fetchBookings, showAvatar } from '../../actions/locations.js'
import { showUpdateAvailableDateForm } from '../../actions/availableDates.js'
import { showUpdateAvailableTimeSlotForm } from '../../actions/availableTimeSlots.js'
import { fetchCompanies } from '../../actions/companies.js'
import { showUpdateBookingForm } from '../../actions/bookings.js'
import Image from 'react-bootstrap/lib/Image';
import AddAvailableDate from '../locations/AddAvailableDate'
import AddAvailableTimeSlot from '../locations/AddAvailableTimeSlot'
import AddBooking from '../locations/AddBooking'

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Toggle from 'material-ui/Toggle';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment'

import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import { hashCode, intToRGB} from '../../utils/colors'

import './LocationCalendar.css'
const style = {
  margin: 0,
};

const toggle = {
  marginLeft: 10,
}

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 25,
}


BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const Calendar = withDragAndDrop(BigCalendar)
function Event({ event }) {
  if (event.type === 'availableTimeSlot') {
    return (
      <span style={{ fontSize: '13px' }}>
        {'Available'}
      </span>
    )
  } else {
    if (event.showAvatar && event.weekType !== 'week' && event.weekType !== 'day') {
      return (
      event.userImage ? 
        (
        <Image className="circle"
          thumbnail
          src={event.userImage} 
          avatar={event.title}
          style={{ width: '15%' }}
        />
        )
        :
        (<div className="attendeeCircle" style={{backgroundColor: '#' + intToRGB(hashCode(event.company))}}>
        <span className="attendeeInitials">{ (event.title.split(" ", 2).map((n)=>n[0]).join("").toUpperCase())}</span></div>)
      )
    } else {
      return (
        <span style={{ fontSize: '13px'}}>
          {event.title}
        </span>
      )
    }

  }
}

function EventAgenda({ event }) {
  return (
    <span style={{ fontSize: '13px' }}>
      <em style={{ color: 'gray' }}>{event.title}</em>
      <p>{event.desc}</p>
    </span>
  )
}

const calendarFormats = {
  dayFormat: (date, culture, localizer) => localizer.format(date, 'ddd MM/DD', culture)
}

class LocationCalendar extends Component {

  static defaultProps = {
    calendarView: 'month',
    calendarDate: moment().toDate(),
    showAvatar: true
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchCompanies())
  }

  closeCalendarDialog() {
    const { dispatch } = this.props
    dispatch(closeLocationCalendar())
  }

  toggleAvatar(event, enabled) {
    const { dispatch } = this.props
      dispatch(showAvatar(enabled))
  }

  dateSelected(date) {
    const { dispatch } = this.props

    if (this.props.calendarView === 'month') {
      
      let dates = this.props.calendarLocation.availableDates
      if (!dates) {
        dates = []
      }

      let availableDate = dates.find(x => moment(x.startDate).isSameOrBefore(moment(date.start)) && moment(x.endDate).isSameOrAfter(moment(date.end)))

      if (!availableDate) {
        availableDate = {
          startDate: date.start,
          endDate: date.end,
        }
      }

      availableDate.locationId = this.props.calendarLocation._id

      dispatch(showUpdateAvailableDateForm(availableDate))
    } else if (this.props.calendarView === 'day' || this.props.calendarView === 'week') {

      let timeSlots = this.props.calendarLocation.availableTimes
      if (!timeSlots) {
        timeSlots = []
      }

      let availableTimeSlot = timeSlots.find(x => moment(x.startDate).isSameOrBefore(moment(date.start)) && moment(x.endDate).isSameOrAfter(moment(date.end)) && x.weekday === moment(date.start).day())

      /* the availableTimeSlot will be set according to [ADM-13]
       The default start time and end time should be populated with whatever values the user entered the previous visit
        → If the user selects one cell. If the user selects a range of cells it should behave as it does today. */

      let lastStartDate = undefined
      let lastEndDate = undefined
      let duration = undefined
      let hours = undefined
      { (this.props.lastStartDate !== undefined) ? (lastStartDate = moment(this.props.lastStartDate)) : (lastStartDate = undefined) }

      { (this.props.lastEndDate !== undefined) ? (lastEndDate = moment(this.props.lastEndDate)) : (lastEndDate = undefined) }

      { lastEndDate && lastStartDate ? (duration = moment.duration(moment(date.end).diff(moment(date.start)))) : null }

      { duration != undefined ? (hours = duration.asHours()) : null }

      if (!availableTimeSlot) {

        availableTimeSlot = {

          startDate:
            (hours <= 1) ?
              (lastStartDate ?
                (lastStartDate)
                :
                (date.start))
              :
              (date.start),

          endDate:
            (hours <= 1) ?
              (lastEndDate ?
                (lastEndDate)
                :
                (date.end))
              :
              (date.end),

          weekday: moment(date.start).day()
        }
      }


      availableTimeSlot.locationId = this.props.calendarLocation._id

      dispatch(showUpdateAvailableTimeSlotForm(availableTimeSlot))
    }

  }

  eventSelected(event) {
    const { dispatch } = this.props

    let booking
    if (event.bookingId) {
      booking = this.props.bookings.find((booking) => {
        return booking._id === event.bookingId
      })
    }

    if (event.bookingId) {
      let bookings = this.props.bookings
      if (!bookings) {
        bookings = []
      }
      let booking = bookings.find(x => x._id === event.bookingId)
      booking.locationId = this.props.calendarLocation._id

      dispatch(showUpdateBookingForm(booking))
    } else {
      let timeSlots = this.props.calendarLocation.availableTimes
      if (!timeSlots) {
        timeSlots = []
      }
      let availableTimeSlot = timeSlots.find(x => x._id === event._id)
      availableTimeSlot.locationId = this.props.calendarLocation._id
      dispatch(showUpdateAvailableTimeSlotForm(availableTimeSlot))
    }

    
  }

  rangeSelected(startDate, endDate) {
    console.log("range selected")
  }

  viewSelected(view) {
    const { dispatch } = this.props
    dispatch(fetchBookings(this.props.calendarLocation))
    dispatch(updateCalendarView(view))

  }

  dateChanged(date) {
    const { dispatch } = this.props
    dispatch(updateCalendarDate(date))
    dispatch(fetchBookings(this.props.calendarLocation))
  }

  customDayPropGetter = date => {

    let isAvailable = false

    for (let availableDate of this.props.calendarLocation.availableDates) {
      if (moment(date).startOf('day').isSameOrAfter(moment(availableDate.startDate).startOf('day')) && moment(date).endOf('day').isSameOrBefore(moment(availableDate.endDate).endOf('day'))) {
        isAvailable = true
        break
      }
    }

    if (isAvailable) {
      return { style: { background: '#afa' } }
    }

    return {}

  }

  customEventPropGetter = event => {
    if (event.type === 'availableTimeSlot') {
      return { style: { backgroundColor: '#00cc99' } }
    } else {
      if (event.company ) {
        if ((this.props.showAvatar && this.props.calendarView == 'week') || !this.props.showAvatar || (this.props.showAvatar && this.props.calendarView == 'day')) {
          return { style: { backgroundColor: '#' + intToRGB(hashCode(event.company))} }
        } else {
            return { style: { backgroundColor: '#00000000'} }
          }
      } else {
        if (this.props.showAvatar ) {
          return { style: { backgroundColor: '#00000000'} }
        }
        else {
          return { style: { backgroundColor: '#' + '000000'} }
        }
        
      }
    }
  }

  customSlotPropGetter = date => {
    return { style: { backgroundColor: 'white' } }
  }

  /* build events based on location time slots and bookings */
  locationEvents1() {
    let events = []

    // add bookings
    for (let booking of this.props.bookings) {
      if (booking.user) {
        let event = {
          bookingId: booking._id,
          title: booking.user.fullName,
          type: 'bookedTimeSlot',
          start: moment(booking.startDate).toDate(),
          end: moment(booking.endDate).toDate()
        }
        events.push(event)
      }
    }
    return events
  }
  locationEvents() {
    let events = []

    let location = this.props.calendarLocation
    let specificAvailableDates = location.availableDates && location.availableDates.length > 0

    if (location && location.availableTimes) {

      /*
        - for MONTH view we display only bookings
        - for DAY view display both bookings and slots as events
      */

      if (this.props.calendarView === 'month') {

        // calculate start & end of month
        let calendarDate = moment(this.props.calendarDate)
        let startMonthDate = moment(this.props.calendarDate).startOf('month').subtract({ weeks: 1 })
        let endMonthDate = moment(this.props.calendarDate).endOf('month').add({ weeks: 1 })
        let testMonthDate = calendarDate.endOf('month')

        while (startMonthDate.isSameOrBefore(endMonthDate)) {

          let displayTimeslots = true

          if (specificAvailableDates) {
            for (let availableDate of location.availableDates) {
              if (startMonthDate.isSameOrAfter(availableDate.startDate) && startMonthDate.isSameOrBefore(availableDate.endDate)) {
                displayTimeslots = true
                break
              }
            }
          } else {
            displayTimeslots = true
          }

          if (displayTimeslots) {
            for (let timeSlot of location.availableTimes) {

              if (timeSlot.weekday == startMonthDate.day()) {

                let startDate = moment(startMonthDate)
                let startTime = moment(timeSlot.startDate)

                startTime.year(startDate.year())
                startTime.month(startDate.month())
                startTime.date(startDate.date())

                let endDate = moment(startMonthDate)
                let endTime = moment(timeSlot.endDate)

                endTime.year(endDate.year())
                endTime.month(endDate.month())
                endTime.date(endDate.date())

                let event = {
                  _id: timeSlot._id,
                  type: 'availableTimeSlot',
                  start: startTime.toDate(),
                  end: endTime.toDate()
                }

                events.push(event)
              }
            }
          }

          startMonthDate = startMonthDate.add({ days: 1 });
        }
      } else if (this.props.calendarView === 'day') {

        let displayTimeslots = true

        if (specificAvailableDates) {
          for (let availableDate of location.availableDates) {
            if (moment(this.props.calendarDate).isSameOrAfter(availableDate.startDate) && moment(this.props.calendarDate).isSameOrBefore(availableDate.endDate)) {
              displayTimeslots = true
              break
            }
          }
        } else {
          displayTimeslots = true
        }

        if (displayTimeslots) {

          let weekday = moment(this.props.calendarDate).day()
          for (let timeSlot of location.availableTimes) {
            if (timeSlot.weekday === weekday) {

              let startDate = moment(this.props.calendarDate)
              let startTime = moment(timeSlot.startDate)

              startTime.year(startDate.year())
              startTime.month(startDate.month())
              startTime.date(startDate.date())

              let endDate = moment(this.props.calendarDate)
              let endTime = moment(timeSlot.endDate)

              endTime.year(endDate.year())
              endTime.month(endDate.month())
              endTime.date(endDate.date())

              let event = {
                _id: timeSlot._id,
                type: 'availableTimeSlot',
                start: startTime.toDate(),
                end: endTime.toDate()
              }

              events.push(event)
            }
          }
        }
      } else if (this.props.calendarView === 'week') {
        for (let timeSlot of location.availableTimes) {

          let startDate = moment(this.props.calendarDate)
          startDate = startDate.day(timeSlot.weekday)

          let displayTimeslot = true

          if (specificAvailableDates) {
            for (let availableDate of location.availableDates) {
              if (startDate.isSameOrAfter(availableDate.startDate) && startDate.isSameOrBefore(availableDate.endDate)) {
                displayTimeslot = true
                break
              }
            }
          } else {
            displayTimeslot = true
          }

          if (!displayTimeslot) {
            continue
          }

          let startTime = moment(timeSlot.startDate)

          startTime.year(startDate.year())
          startTime.month(startDate.month())
          startTime.date(startDate.date())

          let endDate = moment(this.props.calendarDate)
          endDate = endDate.day(timeSlot.weekday)

          let endTime = moment(timeSlot.endDate)

          endTime.year(endDate.year())
          endTime.month(endDate.month())
          endTime.date(endDate.date())

          let event = {
            _id: timeSlot._id,
            type: 'availableTimeSlot',
            start: startTime.toDate(),
            end: endTime.toDate()
          }
          events.push(event)

        }
      }
    }

    // add bookings
    for (let booking of this.props.bookings) {
      if (booking.user) {
        if (booking.user.companies) {
          let companies = this.props.companies
        let companyUser = companies
        companyUser=companyUser.filter((company) => {
          return  company._id === booking.user.companies[0]
        })
  let companyName = companyUser && companyUser.length > 0 ? (companyUser[0].name):null
        let event = {
          bookingId: booking._id,
          company: companyName ,
          title: booking.user.fullName,
          userImage: booking.user.image,
          type: 'bookedTimeSlot',
          start: moment(booking.startDate).toDate(),
          end: moment(booking.endDate).toDate(),
          showAvatar: this.props.showAvatar,
          weekType: this.props.calendarView
        }
        events.push(event)
        }
        
      }
    }

    return events
  }

  render() {
   
    

    if (this.props.calendarLocation && this.props.bookings) {

      if (!this.props.showAvatar) {
       console.log(this.props.ShowAvatar)
      } else {
        console.log(this.props.ShowAvatar)

      }

      const actions = [
        <FlatButton
          label="Close"
          primary={true}
          onClick={this.closeCalendarDialog.bind(this)}
        />,
      ];

      return (

        <Dialog
        
          autoDetectWindowHeight={false}
          autoScrollBodyContent={true}
          contentStyle={{ width: "80%", maxWidth: "none", transform: "translate(0px, 0px)" }}
          actions={actions}
          title="Calendar Location"
          fullScreen={true}
          modal={true}
          open={this.props.calendarLocation != null && this.props.bookings != null}>
          {/* <br/> */}
          
          <div style={{ height: "100vh", border: 'none' }}>
            <AddBooking />
            <AddAvailableDate />
            <AddAvailableTimeSlot />
            {this.props.calendarView === 'month'? 
            (<div style={{float: 'right'}}>
            <Toggle
               onToggle={this.toggleAvatar.bind(this)}
                toggled= {this.props.showAvatar}
                label= 'Show Avatar'
                labelPosition="right"
                style={toggle}
              />
            </div>)
            :
            (<div></div>)}
            
            <br/>
            <br/>
            <br/>
            <Calendar

              events={this.locationEvents()}
              views={['month', 'week', 'day', 'agenda']}
              defaultView={'month'}
              step={60}
              min-height={500}
              // showMultiDayTimes
              selectable={'true'}
              defaultDate={moment().toDate()}
              onSelectSlot={this.dateSelected.bind(this)}
              onSelectEvent={this.eventSelected.bind(this)}
              onSelecting={this.rangeSelected.bind(this)}
              onView={this.viewSelected.bind(this)}
              onNavigate={this.dateChanged.bind(this)}
              dayPropGetter={this.customDayPropGetter.bind(this)}
              slotPropGetter={this.customSlotPropGetter.bind(this)}
              eventPropGetter={this.customEventPropGetter.bind(this)}
              drilldownView="day"
              formats={calendarFormats}
              components={{
                event: Event,
                agenda: {
                  event: EventAgenda
                }
              }}
            />

          </div>
        </Dialog>)
    } else {
      return (<div />)
    }
  }
}

const mapStateToProps = state => {
  return state.locationsReducer
}

export default withRouter(
  connect(mapStateToProps)(LocationCalendar)
);



// WEBPACK FOOTER //
// ./src/components/locations/LocationCalendar.js